<template>
  <b-card
    :class="{panelHover: hover && !panelconfig.noHover}"
    no-body
    @mouseover="hover = true"
    @mouseleave="hover = false"
  >
    <b-card-title
      v-if="!panelconfig.noHover"
      class="ml-2 mt-2"
    >
      Line Chart
    </b-card-title>

    <!-- Meta Info -->
    <div
      v-if="panelconfig.noHover"
      class="d-flex mt-1 small text-muted justify-content-between "
    >
      <b-col
        class="text-left"
      >
        <feather-icon
          size="15"
          icon="CpuIcon"
        />
        {{ dataSource.name }}
      </b-col>
      <!--
      <b-col
        v-if="!edit"
        class="text-right"
        @click="showInfo = !showInfo"
      >
        <feather-icon
          size="15"
          icon="InfoIcon"
        />
      </b-col>
      -->
      <b-col
        v-if="edit"
        class="text-right"
      >
        <feather-icon
          v-if="edit"
          icon="EditIcon"
          class="text-primary cursor-pointer mr-2"
          size="18"
          variant="primary"
          @click="$emit('editPanel')"
        />
        <feather-icon
          v-if="edit"
          icon="XCircleIcon"
          class="text-danger cursor-pointer"
          size="20"
          variant="danger"
          @click="$emit('removeItem')"
        />

      </b-col>
    </div>

    <b-card-header class="align-items-baseline">
      <div>
        <b-card-title class="mb-25">
          {{ dataField.name }}
        </b-card-title>
        <b-card-text class="mb-0">
          {{ statistic + ' ' }}
        </b-card-text>
      </div>
      <feather-icon
        icon="SettingsIcon"
        size="18"
        class="text-muted cursor-pointer"
      />
    </b-card-header>
    <b-card-body class="pb-0">

      <!-- apex chart -->
      <vue-apex-charts
        v-if="series[0].data.length > 0"
        type="line"
        height="450"
        :options="chartOptions"
        :series="series"
      />
    </b-card-body>
    <!-- Footer -->
    <div
      v-if="panelconfig.noHover"
      class="d-flex mb-1 mt-1 small text-muted"
    >
      <b-col
        class="text-left"
      >
        <feather-icon
          size="16"
          icon="ClockIcon"
        />
        {{ timestamp }}
      </b-col>
    </div>
  </b-card>
</template>

<script>
import {
  BCard, BCardHeader, BCardTitle, BCardBody, BCardText, BCol,
} from 'bootstrap-vue'
import VueApexCharts from 'vue-apexcharts'
import { $themeColors } from '@themeConfig'
import { API } from 'aws-amplify'
import * as queries from '../../../../../../graphql/queries'

export default {
  components: {
    VueApexCharts,
    BCard,
    BCardHeader,
    BCardText,
    BCardTitle,
    BCardBody,
    BCol,
  },
  props: {
    panelconfig: {
      type: Object,
      default: () => ({
        dataSources: [],
        statistic: '',
        statisticTitle: '',
        icon: {
          title: '',
          id: '',
        },
        color: '',
        hover: false,
      }),
    },
    edit: {
      type: Boolean,
      default: false,
    },
    item: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      dataSource: {
        id: '',
        name: 'Loading',
        unit: '',
      },
      dataField: {
        name: 'Loading',
        unit: '',
      },
      hover: false,
      statistic: '',
      timestamp: '',
      series: [],
      chartOptions: {
        chart: {
          id: 'area-datetime',
          type: 'area',
          height: 500,
          zoom: {
            autoScaleYaxis: true,
          },
        },
        dataLabels: {
          enabled: false,
        },
        markers: {
          size: 0,
          style: 'hollow',
        },
        xaxis: {
          type: 'datetime',
          min: '',
          tickAmount: 1,
        },
        yaxis: {
          title: {
            text: '',
          },
        },
        tooltip: {
          x: {
            format: 'HH:mm:ss dd MMM yyyy',
          },
        },
        stroke: {
          curve: 'smooth',
          width: 3,
        },
        colors: [$themeColors.primary],
      },
    }
  },
  computed: {
    icon: {
      get() {
        if (this.panelconfig.icon) {
          return this.panelconfig.icon.id
        }
        return 'CpuIcon'
      },
      set(value) {
        this.panelconfig.icon = value
      },
    },
    color: {
      get() {
        if (this.panelconfig.color) {
          return this.panelconfig.color
        }
        return 'primary'
      },
      set(value) {
        this.panelconfig.color = value
      },
    },
  },
  watch: {
    panelconfig: {
      handler(newVal) {
        // check if the data source has changed and if so, get the new data and set the old data source id if not changed do nothing
        if (this.oldDataSourceId !== newVal.dataSources[0].id) {
          this.oldDataSourceId = newVal.dataSources[0].id
          this.getDevice()
        } else if (this.oldSensorId !== newVal.dataSources[0].sensorId) {
          this.oldSensorId = newVal.dataSources[0].sensorId
          this.getDataField()
        } else if (this.oldDataSourceId === newVal.dataSources[0].id || this.oldSensorId === newVal.dataSources[0].sensorId) {
          this.doneLoading = true
        } else {
          this.doneLoading = true
          this.dataSource = {
            id: '',
            name: 'CPU',
          }
          this.dataField = {
            name: 'Temperature',
            unit: 'C',
          }
          this.series = [
            {
              name: 'Subscribers',
              data: [
                [1327359600000, 30.95],
                [1327446000000, 31.34],
                [1327532400000, 31.18],
                [1327618800000, 31.05],
                [1327878000000, 31.0],
                [1327964400000, 30.95],
                [1328050800000, 31.24],
                [1328137200000, 31.29],
                [1328223600000, 31.85],
                [1328482800000, 31.86],
                [1328569200000, 32.28],
                [1328655600000, 32.1],
                [1328742000000, 32.65],
                [1328828400000, 32.21],
                [1329087600000, 32.35],
                [1329174000000, 32.44],
                [1329260400000, 32.46],
                [1329346800000, 32.86],
                [1329433200000, 32.75],
                [1329778800000, 32.54],
                [1329865200000, 32.33],
                [1329951600000, 32.97],
                [1330038000000, 33.41],
                [1330297200000, 33.27],
                [1330383600000, 33.27],
                [1330470000000, 32.89],
                [1330556400000, 33.1],
                [1330642800000, 33.73],
                [1330902000000, 33.22],
                [1330988400000, 31.99],
                [1331074800000, 32.41],
                [1331161200000, 33.05],
                [1331247600000, 33.64],
                [1331506800000, 33.56],
                [1331593200000, 34.22],
                [1331679600000, 33.77],
                [1331766000000, 34.17],
                [1331852400000, 33.82],
                [1332111600000, 33.52],
              ],
            },
          ]
          this.statistic = '21'
          this.timestamp = ''
          this.object = {}
        }
      },
      deep: true,
    },
  },
  created() {
    if (this.panelconfig.dataSources.length > 0) {
      this.doneLoading = false
      this.getDevice()
      this.getDataField()
    } else {
      this.doneLoading = true
      this.dataSource = {
        id: '',
        name: 'CPU',
      }
      this.dataField = {
        name: 'Temperature',
        unit: 'C',
      }
      this.series = [
        {
          name: 'Subscribers',
          data: [
            [1327359600000, 30.95],
            [1327446000000, 31.34],
            [1327532400000, 31.18],
            [1327618800000, 31.05],
            [1327878000000, 31.0],
            [1327964400000, 30.95],
            [1328050800000, 31.24],
            [1328137200000, 31.29],
            [1328223600000, 31.85],
            [1328482800000, 31.86],
            [1328569200000, 32.28],
            [1328655600000, 32.1],
            [1328742000000, 32.65],
            [1328828400000, 32.21],
            [1329087600000, 32.35],
            [1329174000000, 32.44],
            [1329260400000, 32.46],
            [1329346800000, 32.86],
            [1329433200000, 32.75],
            [1329778800000, 32.54],
            [1329865200000, 32.33],
            [1329951600000, 32.97],
            [1330038000000, 33.41],
            [1330297200000, 33.27],
            [1330383600000, 33.27],
            [1330470000000, 32.89],
            [1330556400000, 33.1],
            [1330642800000, 33.73],
            [1330902000000, 33.22],
            [1330988400000, 31.99],
            [1331074800000, 32.41],
            [1331161200000, 33.05],
            [1331247600000, 33.64],
            [1331506800000, 33.56],
            [1331593200000, 34.22],
            [1331679600000, 33.77],
            [1331766000000, 34.17],
            [1331852400000, 33.82],
            [1332111600000, 33.52],
          ],
        },
      ]
      this.statistic = '21'
      this.timestamp = ''
      this.object = {}
    }
  },
  methods: {
    async getDevice() {
      const getDeviceResponse = await API.graphql({
        query: queries.getDevice,
        variables: {
          id: this.panelconfig.dataSources[0].id,
        },
      })
      if (getDeviceResponse.data.getDevice != null) {
        this.doesNotExist = false
        this.dataSource = getDeviceResponse.data.getDevice
        if (this.dataSource.objectDevicesId != null) {
          this.getObject()
        }
      } else {
        this.doesNotExist = true
        this.doneLoading = true
      }
    },
    async getObject() {
      await API.graphql({
        query: queries.getObject,
        variables: {
          id: this.dataSource.objectDevicesId,
        },
      }).then(response => {
        this.object = response.data.getObject
      })
    },
    async getDataField() {
      const getDataFieldResponse = await API.graphql({
        query: queries.getSensor,
        variables: {
          id: this.panelconfig.dataSources[0].sensorId,
        },
      })
      if (getDataFieldResponse.data.getSensor != null) {
        this.dataField = getDataFieldResponse.data.getSensor
        this.getData()
      }
    },
    async getData() {
      this.doneLoading = false
      const workspace = JSON.parse(localStorage.getItem('workspace')).id
      const getWorkspaceResponse = await API.graphql({
        query: queries.getWorkspace,
        variables: {
          id: workspace,
        },
      })
      this.workspacetoken = getWorkspaceResponse.data.getWorkspace.workspacetoken
      const db = `${getWorkspaceResponse.data.getWorkspace.id}.${process.env.VUE_APP_AMPLIFY_ENV}`
      const table = this.dataSource.deviceModelDevicesId
      const apiName = 'TimestreamAPI'
      const path = '/items'
      const query = `SELECT * FROM "${db}"."${table}" where id = '${this.panelconfig.dataSources[0].id}' and measure_name = '${this.dataField.identifier}' ORDER BY time DESC LIMIT 1000`
      const myInit = {
        headers: {
          workspace,
          workspacetoken: this.workspacetoken,
        },
        queryStringParameters: {
          query,
        },
      }
      await API.get(apiName, path, myInit).then(response => {
        if (response.timestreamData[0].length === 0) {
          this.statistic = 'No Data'
          this.timestamp = 'No Data'
          this.series = [
            {
              name: this.dataField.name,
              data: [],
            },
          ]
          this.doneLoading = true
        } else {
          const values = []
          response.timestreamData[0].forEach(item => {
            const measureValue = item['measure_value::double']
            const dateTime = item.time
            values.push([dateTime, measureValue])
          })
          const xMin = new Date(response.timestreamData[0][response.timestreamData[0].length - 1].time)
          this.chartOptions.xaxis.min = xMin
          this.chartOptions.xaxis.max = new Date().getTime() // Set the max to the current timestamp
          this.series = [
            {
              name: this.dataField.name,
              data: values,
            },
          ]
          // this.statistic = values[values.length - 1]
          const date = new Date(response.timestreamData[0][0].time)
          this.timestamp = date.toLocaleString()
          // Get the timestamp of the last value

          this.doneLoading = true
        }
      })
    },
  },
}
</script>
<style lang="scss">
.panelHover {
  position: relative;
   width: 100%; /* Full width (cover the whole page) */
  height: 100%; /* Full height (cover the whole page) */
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(45, 177, 85, 0.153); /* Black background with opacity */
  z-index: 0; /* Specify a stack order in case you're using a different order for other elements */
  cursor: pointer; /* Add a pointer on hover */
}
</style>
